import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, CampaignListIcon } from 'assets/icons';
import { ProductService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import ModalUpload from './modal-upload';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Products extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Precio',
			'Categoría',
			'Marca',
			'Módelo',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		visible_upload: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Productos',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ProductService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.products?.rows || [],
			last_page: res.products?.count || 0
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el producto?',async () => {
			await ProductService.delete({
				product_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el producto correctamente");
			this.load(true);
		});
	}

	onCloseUpload = () => {
		this.setState({
			visible_upload: false
		},() => this.load(true));
	}

	upload = () => {
		this.setState({
			visible_upload: true
		});
	}

	render() {
		const { visible, visible_upload } = this.state;

		return (
			<div id="client-products">
		      	<Modal
		          className="modal-create-product"
		          visible={ visible }
		          title={ `${ this.state.item != null ? 'Editar' : 'Creación de' } Producto` }
		          onClose={ () => this.onClose() }
		        >
		       	  {/*
		       	  // @ts-ignore */}
		          <ModalCreate
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-upload-product"
		          visible={ visible_upload }
		          title="Subida de productos (Excel)"
		          onClose={ () => this.onCloseUpload() }
		        >
		          <ModalUpload
		            onClose={ () => this.onCloseUpload() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							placeholder="Buscar"
							searchLeft={ true }
							className="input-table"
							onSubmit={ () => this.load() }
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-1">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
					<div className="col-md-7 text-right">
						<button className="btn add-btn upload" onClick={ this.upload }>
							<img src={ AddIcon } />
							<p>Subir Productos</p>
						</button>
						<button className="btn add-btn" onClick={ this.add }>
							<img src={ AddIcon } />
							<p>Nuevo</p>
						</button>
					</div>
				</div>

				<Table title="Productos" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ i.price ? Globals.formatMiles(i.price,true,i.currency ? i.currency : '') : '-' }</td>
								<td>{ i.category || '-' }</td>
								<td>{ i.brand || '-' }</td>
								<td>{ i.model || '-' }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Products);